import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

type PspErrorBoxProps = BoxProps & {
  $isNative: boolean;
};

export const PspErrorIconBox = ({ $isNative, style, ...props }: PspErrorBoxProps) => (
  <Box
    {...props}
    style={[
      styles.pspErrorIconBox,
      $isNative ? styles.pspErrorIconBoxNative : styles.pspErrorIconBoxWeb,
      style,
    ]}
  />
);

export const PspErrorTitleBox = ({ $isNative, style, ...props }: PspErrorBoxProps) => (
  <Box
    {...props}
    style={[
      styles.pspErrorTitleBox,
      $isNative ? styles.pspErrorTitleBoxNative : styles.pspErrorTitleBoxWeb,
      style,
    ]}
  />
);

const styles = StyleSheet.create({
  pspErrorIconBox: {
    alignItems: 'center',
    alignSelf: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  pspErrorIconBoxNative: {
    marginBottom: spacing.$4,
  },
  pspErrorIconBoxWeb: {
    marginBottom: spacing.$1,
  },
  pspErrorTitleBox: {
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  pspErrorTitleBoxNative: {
    marginTop: spacing.$4,
  },
  pspErrorTitleBoxWeb: {
    marginTop: spacing.$2,
  },
});
